import { getAuthorsBio } from '@/services/authorsBio'

import HeaderSemiversatile from '../HeaderSemiversatile'

const HeaderSemiVersatileWrapper = ({ moduleData, ...rest }: any) => {
  return (
    <HeaderSemiversatile moduleData={moduleData} authorBio={rest.authorsBio} />
  )
}
export default HeaderSemiVersatileWrapper
